<template>
    <div>
        <az-back-button :route="rotaVolta" text="Voltar para listagem"/>
        <az-container>
            <div class="az-tabs de-abas">
                <v-tabs left class="de-abas__area pl-5" v-model="abaAtiva">
                    <div>
                        <v-tab v-for="aba in abas"
                               :key="aba.ordem"
                               exact
                               :to="construirRota(aba)"
                               exact-active-class="active"
                               class="de-abas__item">
                            <span class="de-abas__badge">{{aba.ordem}}</span>
                            {{aba.titulo}}
                        </v-tab>
                    </div>
                </v-tabs>

                <transition name="fade" mode="out-in">
                    <router-view/>
                </transition>
            </div>
        </az-container>
    </div>
</template>

<script>
import {actionTypes, mutationTypes, situacoesCompraDireta} from '@/core/constants'
import {mapState} from 'vuex'
export default {
    name: 'CompraDiretaLegadaDetalhes',
    components: {},
    data() {
        return {
            abas: [
                {
                    titulo: 'Dados Gerais',
                    rotaPadrao: 'CompraDiretaLegadaDetalhesCapa',
                    ordem: 1
                },
                {
                    titulo: 'Itens',
                    rotaPadrao: 'CompraDiretaLegadaDetalhesItens',
                    ordem: 2
                },
                {
                    titulo: 'Resultado',
                    rotaPadrao: 'CompraDiretaLegadaDetalhesResultado',
                    ordem: 3
                }
            ],
            abaAtiva: 1,
            processoAquisicaoId: null,
            rotaOrigem: this.$store.state.rota.origem,
            situacoesCompraDireta,
            execucoes: []
        }
    },
    computed: {
        ...mapState(['rotaVolta', 'execucaoAtiva']),
        execucaoAtivaId(){
            return this.execucaoAtiva && this.execucaoAtiva.id
        }
    },
    async beforeRouteUpdate(to, from, next) {

        try {
            this.setProcessoAquisicaoId()
            next()
        } catch (e) {
            if (e.message.includes('is undefined')) {
                this.mostrarNotificacaoErroDefaultEReload()
            } else {
                this.mostrarNotificacaoErro(e.message)
            }
        }
    },
    async created() {
        try {
            this.setProcessoAquisicaoId()
        } catch (e) {
            this.mostrarNotificacaoErro(e.message)
        }
    },
    mounted() {
        this.$store.commit(mutationTypes.SET_RETRAIR_MENU)
        this.buscarExecucoesProcesso()
    },
    methods: {
        setProcessoAquisicaoId() {
            this.processoAquisicaoId = this.$route.params.id
        },
        async buscarExecucoesProcesso(){
            const resultado = await this.$store.dispatch(actionTypes.LEGADO.BUSCAR_EXECUCOES_POR_PROCESSO, this.processoAquisicaoId)

            if(resultado.execucoes.length) {
                const execucaoZero = resultado.execucoes.find(ex => ex.repeticao === 0) || resultado.execucoes[0]

                this.$store.commit(mutationTypes.SET_EXECUCAO_ATIVA, execucaoZero)
            }
        },
        construirRota(aba) {
            if(aba.ordem !== 3)
                return {
                    name: aba.rotaPadrao,
                    params: { id: this.processoAquisicaoId, execucaoId: this.execucaoAtivaId },
                    query: this.$route.query
                }
            else
                return `/comprador/compras-diretas/legadas/${this.processoAquisicaoId}/execucoes/${this.execucaoAtivaId}/resultado`
        },
    },
    destroyed() {
        this.$store.commit(mutationTypes.SET_EXPANDIR_MENU)
    }
}
</script>

<style scoped lang="stylus">
.de-abas__item
    cursor pointer

.menu-opcoes
    width 50px
</style>
